export default __webpack_public_path__ + "static/media/icon_user.8570d391.svg";